'use client'

import { useRef, useState, useEffect } from 'react'

export function StickyVideo() {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [isPlaying, setIsPlaying] = useState(true)
  const [duration, setDuration] = useState(3)
  const [videoStarted, setVideoStarted] = useState(false)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return
    const onLoaded = () => setDuration(video.duration)
    const onPlay = () => setVideoStarted(true)
    video.addEventListener('loadedmetadata', onLoaded)
    video.addEventListener('play', onPlay)
    if (video.readyState >= 1) onLoaded()
    return () => {
      video.removeEventListener('loadedmetadata', onLoaded)
      video.removeEventListener('play', onPlay)
    }
  }, [])

  useEffect(() => {
    const video = videoRef.current
    if (!video) return
    if (isPlaying) {
      video.play().catch(() => {})
    } else {
      video.pause()
    }
  }, [isPlaying])

  return (
    <>
      <video
        ref={videoRef}
        src="/projects/avp/AnimationAVP.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
      />
      <style>{`
        @keyframes progress-ring {
          from { stroke-dashoffset: 125.66; }
          to   { stroke-dashoffset: 0; }
        }
      `}</style>
      <button
        type="button"
        onClick={() => setIsPlaying((p) => !p)}
        aria-label={isPlaying ? 'Pause' : 'Play'}
        className="absolute top-5 right-5 z-10 p-0 border-0 bg-transparent cursor-pointer"
      >
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="20" stroke="rgba(255,255,255,0.25)" strokeWidth="2" />
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="white"
            strokeWidth="2"
            strokeDasharray="125.66"
            strokeLinecap="round"
            transform="rotate(-90 24 24)"
            style={{
              animationName: 'progress-ring',
              animationDuration: `${duration}s`,
              animationTimingFunction: 'linear',
              animationIterationCount: 'infinite',
              animationPlayState: isPlaying && videoStarted ? 'running' : 'paused',
            }}
          />
          {isPlaying ? (
            <>
              <rect x="19" y="17" width="3.5" height="14" rx="1.5" fill="white" />
              <rect x="26" y="17" width="3.5" height="14" rx="1.5" fill="white" />
            </>
          ) : (
            <polygon points="21,17 21,31 32,24" fill="white" />
          )}
        </svg>
      </button>
    </>
  )
}
